import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import {toggleModal} from "../helpers"
import SideBar from "./Sidebar"
import { useState } from "preact/hooks"
import SelectedFilters from "./SelectedFilters"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function Toolbar({ lableFor, isMobile, isTwoProductsInLayout, setIsTwoProductsInLayout }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    // const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`
    const totalSummary = `${docCount} Products`;

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const [isClicked, setIsClicked] = useState(false);

    console.log(pageType);

    return (
        // ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2 ns-flex-column ns-flex-wrap
    
        <div
            class="ns-header-controls ns-d-flex ns-flex-md-row ns-d-none ns-d-md-flex ns-align-items-center ns-justify-content-between"
            // style={loading ? "opacity: 0.3; justify-content: between !important;" : ""}
            style={pageType === "search" ? "border-top: .5px solid #818181;" : ""}
        >
            {/* ns-d-md-block ns-mb-4 ns-flex-wrap*/}
            {/* <ToggleMobileSidebarButton
                lableFor={lableFor}
                selectedFiltersCount={selectedFiltersCount}
            /> */}
            {/* nos-w-100 */}

            {/* "Filter btn" */}
             <div class="ns-d-flex"> 
                <SideBar isClicked={isClicked} setIsClicked={setIsClicked} isMobile={isMobile}/>
                {!isMobile && <SelectedFilters />}
             </div>

            <div class="ns-d-flex ns-justify-content-between ns-align-items-center ns-toolbar-right">
                <div class="ns-d-none ns-d-md-flex ns-align-items-center ns-sort-by-icon">
                    <svg class="icon icon-sort-by icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" role="graphics-symbol" focusable="false">
                        <title>Sort by</title>
                        <path d="M4 7H20" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M7 12H17" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M10 17H14" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <label for="sortby" class="ns-sort-by">Sort By</label>
                </div>
                {!isMobile && <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                />}
                {!loading && (
                    // ns-order-3 ns-order-md-first ns-d-inline ns-text-align-center ns-d-md-block ns-align-self-md-center ns-color-black
                    <>
                    <span
                        class="ns-prod-count"
                        data-nosto-element="totalResults"
                    >
                        {totalSummary}
                    </span>
                    {isMobile && (<div class="layout-switchers">
                        <div class={`layout-switch layout-switch--two-columns ${isTwoProductsInLayout ? "layout-switch--active": '' }`} onClick={()=>{
                            setIsTwoProductsInLayout(true);
                            }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down">
                            <polyline points="2 2 10 2 10 10 2 10 2 2"></polyline>
                            <polyline points="14 2 22 2 22 10 14 10 14 2"></polyline>
                            <polyline points="14 14 22 14 22 22 14 22 14 14"></polyline>
                            <polyline points="2 14 10 14 10 22 2 22 2 14"></polyline>
                        </svg>
                        </div>
                        <div class={`layout-switch layout-switch--one-column ${!isTwoProductsInLayout ? "layout-switch--active": '' }`} onClick={()=>{
                            setIsTwoProductsInLayout(false);
                            }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down">
                            <polyline points="2 2 22 2 22 22 2 22 2 2"></polyline>
                        </svg>
                        </div>
                    </div>)}
                 </>
                )}
            </div>
            {/* {isMobile && <SelectedFilters isMobile={isMobile}/>} */}
        </div>
        
    )
}
